import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Transaction, ORDER_STATUS, TRANSACTION_CATEGORY_TYPE } from '../../model/myria/app/transaction';
import { TranslateService } from '@ngx-translate/core';
import { getCurrencySymbol } from '@angular/common';
import { AlertController } from 'ionic-angular';
import { LoadingProvider } from '../../providers/loading/loading';
import { OrderProvider } from '../../providers/order/order';
import { RmtPopupComponent } from './../../components/rmt-popup/rmt-popup';
import { AnalyticsEventType } from '../../model/types/analytics.const';
import { RouteProvider } from '../../providers/route/route';
import { PaymentMethodType } from '../../model/types/payment-method-type';
import { SegmentProvider } from '../../providers/analytics/segment';
import { APP_CONFIG, Region } from '../../environment';
import { DELIVERY_METHOD } from '../../providers/myria/app-variables';
import { UtilsProvider } from '../../providers/myria/utils-provider';
import { ColorProvider } from '../../providers/color/color';
import { SendAgainProvider } from '../../providers/send-again/send-again';

@Component({
  selector: 'activity-item',
  templateUrl: 'activity-item.html'
})
export class ActivityItemComponent {
  @ViewChild('share') share;
  @Input() transaction: Transaction;
  @Input() cardId:string;
  @Input() primaryBtndId:string;
  @Input() secondaryBtnId:string;
  @Input() transactionBefeficiaryId: string;
  @Output() selectEmitter: EventEmitter<any> = new EventEmitter();

  primaryButtonText: string;
  primaryAction: any;
  hidePrimaryButton: boolean = false;
  hasSecondaryButton: boolean;
  secondaryButtonText: string;
  secondaryAction: any;

  sendLabel: string;
  beneficiaryName: string;
  statusIcon: string;
  statusTextColor: string;
  statusText: string;

  ngOnInit() {
    this.init();
    this.buildName();
  }

  constructor(
    private alertCtrl: AlertController,
    private translate: TranslateService,
    private loadingProvider: LoadingProvider,
    private orderProvider: OrderProvider,
    private sendAgainProvider: SendAgainProvider,
    private routeProvider: RouteProvider,
    private analytics: SegmentProvider,
    private utilsProvider: UtilsProvider
  ) {}

  init() {
    //TODO: Remove once test are finished
    switch(this.transaction.StatusId) {
      case ORDER_STATUS.PAYMENT_PENDING:
        this.sendLabel = 'page.activityPage.orderStatusInProgressText';
        this.statusIcon = 'custom-icon-order-funding';
        this.statusTextColor = ColorProvider.getColorValue('--app-primary');
        this.statusText = 'page.activityPage.orderStatusUnfundedText';
        this.initFundButtons();
        break;
      case ORDER_STATUS.UNFUNDED:
      case ORDER_STATUS.PAYMENT_PENDING:
        this.sendLabel = 'page.activityPage.orderStatusInProgressText';
        this.statusIcon = 'custom-icon-order-funding';
        this.statusTextColor = ColorProvider.getColorValue('--app-primary');;
        this.statusText = 'page.activityPage.orderStatusUnfundedText';
        this.initFundButtons();
        break;
      case ORDER_STATUS.COMPLETED:
        this.sendLabel = 'page.activityPage.orderStatusCompletedText';
        this.statusIcon = 'custom-icon-order-ready';
        this.statusTextColor = ColorProvider.getColorValue('--green-300');;
        this.statusText = 'page.activityPage.orderStatusTransferCompletedText';
        this.initSendAgainButtons();
        break;
      case ORDER_STATUS.PROCESSING:
        this.sendLabel = 'page.activityPage.orderStatusInProgressText';
        this.statusIcon = 'custom-icon-order-processed';
        this.statusTextColor = '$ria-dark-text-secondary';
        this.statusText = 'page.activityPage.orderStatusProcessedText';
        this.initShareButtons();
        break;
      case ORDER_STATUS.BENEFICIARY_CAN_COLLECT:
        this.sendLabel = 'page.activityPage.orderStatusInProgressText';
        this.statusIcon = 'custom-icon-order-processed';
        this.statusTextColor = '$ria-dark-text-secondary';
        this.statusText = 'page.activityPage.orderStatusReadyForPickupText';
        this.initShareButtons();
        break;
      case ORDER_STATUS.COLLECTED_BY_BENEFICIARY:
        this.sendLabel = 'page.activityPage.orderStatusCompletedText';
        this.statusIcon = 'custom-icon-order-ready';
        this.statusTextColor = ColorProvider.getColorValue('--green-300');
        this.statusText = 'page.activityPage.orderStatusTransferCompletedText';
        this.initSendAgainButtons();
        break;
      case ORDER_STATUS.AVAILABLE_TO_REFUND:
        this.sendLabel = 'page.activityPage.orderStatusCanceledText';
        this.statusIcon = 'custom-icon-order-processed';
        this.statusTextColor = '$ria-dark-text-secondary';
        this.statusText = 'page.activityPage.orderStatusRefundPending';
        this.initSendAgainButtons();
        break;
      case ORDER_STATUS.CANCELLED:
        this.sendLabel = 'page.activityPage.orderStatusCanceledText';
        this.statusIcon = 'custom-icon-order-cancelled';
        this.statusTextColor = ColorProvider.getColorValue('--red-300');
        this.statusText = 'page.activityPage.orderStatusTransferCanceledText';
        this.initSendAgainButtons();
        break;
      case ORDER_STATUS.COLLECTED_BY_BENEFICIARY:
        this.sendLabel = 'page.activityPage.orderStatusCompletedText';
        this.statusIcon = 'custom-icon-order-ready';
        this.statusTextColor = ColorProvider.getColorValue('--green-300');
        this.statusText = 'page.activityPage.orderStatusTransferCompletedText';
        this.initSendAgainButtons();
        break;
      case ORDER_STATUS.EXPIRED:
        this.sendLabel = 'page.activityPage.orderStatusCanceledText';
        this.statusIcon = 'custom-icon-order-expired';
        this.statusTextColor = ColorProvider.getColorValue('--red-300');
        this.statusText = 'page.activityPage.orderStatusTransferExpiredText';
        this.initSendAgainButtons();
        break;
      case ORDER_STATUS.REFUNDED:
        this.sendLabel = 'page.activityPage.orderStatusCanceledText';
        this.statusIcon = 'custom-icon-order-ready';
        this.statusTextColor = ColorProvider.getColorValue('--green-300');
        this.statusText = 'page.activityPage.orderStatusRefunded';
        this.initSendAgainButtons();
      break;
    }
  }

  initFundButtons() {
    this.hasSecondaryButton = true;
    this.secondaryButtonText = 'page.activityPage.detailsButton';
    this.secondaryAction = () => this.emit();
    this.primaryButtonText = 'page.activityPage.fundTransfer';
    this.primaryAction = () => this.fundAction();
  }

  initShareButtons() {
    this.hasSecondaryButton = true;
    this.secondaryButtonText = 'page.activityPage.shareButton';
    this.secondaryAction = () => this.shareAction();
    this.primaryButtonText = 'page.activityPage.detailsButton';
    this.primaryAction = () => this.emit();    
  }

  initSendAgainButtons() {
    this.hasSecondaryButton = true;
    this.secondaryButtonText = 'page.activityPage.detailsButton';
    this.secondaryAction = () => this.emit();
    this.primaryButtonText = 'page.activityPage.sendAgainButton';
    this.primaryAction = () => this.sendAgainAction();
    if (this.transaction.CanResend === false)
      this.hidePrimaryButton = true;
    else if (this.transaction.DelivMethod === DELIVERY_METHOD.MOBILE_PAYMENT.Id) // temporary: send again deactivated for mobile wallets
      this.hidePrimaryButton = true;
  }
  
  emit() {
    this.selectEmitter.emit();
  }

  shareAction() {
    if (!this.share.orderPromise)
      this.share.orderPromise = this.orderProvider.getOrderStatus(this.transaction.OrderNo);
    this.share.shareTransactionDetails();
  }

  buildName() {
    this.beneficiaryName = this.transaction.BeneficiaryFirstName + ' ' + this.transaction.BeneficiaryFirstLastName;
  }

  primaryButtonAction() {
    if (this.primaryAction) this.primaryAction();
  }

  secondaryButtonAction() {
    if (this.secondaryAction) this.secondaryAction();
  }

  getCurrencyIcon() {
    const icon = getCurrencySymbol(this.transaction.Currency, 'wide');
    return icon;
  }

  async fundAction() {
    this.loadingProvider.show();
    const order = await this.orderProvider.getOrderStatus(this.transaction.OrderNo);

    this.analytics.trackEvent({ eventName: AnalyticsEventType.FundingStarted, analyticsData: this.orderProvider.getAnalyticsDataFromTransaction(this.transaction, order)});
    
    if (APP_CONFIG.region.region === Region.CL) {
      if (order.paymentMethod === PaymentMethodType.SencillitoOnline) {
        this.routeProvider.openModal(this.routeProvider.pages.SendPaymentPendingSencillito, { transaction: this.transaction, paymentMethod: this.transaction.PaymentMethod });
      }
      else {
        this.routeProvider.openModal(this.routeProvider.pages.SendPaymentPendingPayInStore, { transaction: this.transaction, paymentMethod: this.transaction.PaymentMethod });
      }
    }
    else if (order.paymentMethod === PaymentMethodType.PayID) this.routeProvider.openModal(this.routeProvider.pages.SendPaymentPendingPayID, { transaction: this.transaction,paymentMethod: this.transaction.PaymentMethod });
    else if (order.paymentMethod === PaymentMethodType.StagedOnline) this.orderProvider.setPaynowRoute(this.transaction);
    else if(order.paymentMethod === PaymentMethodType.StagedRia) this.orderProvider.setBarcodeRoute(this.transaction, order, false, true);
    else this.routeProvider.openModal(this.routeProvider.pages.SendPayNearMePage, { order: order });
    this.loadingProvider.hide();
  }

  async sendAgainAction() {
    this.loadingProvider.show();
    const sendAgainOrder = await this.orderProvider.getOrderStatus(this.transaction.OrderNo, true);
    let header = this.translate.instant('page.activityPage.sendAgainButton');
    this.transaction.TransferAmount = null;
    this.loadingProvider.showDelayed();
    try {
      await this.sendAgainProvider.processSendAgain(sendAgainOrder, header);
    } catch (ex) {
      RmtPopupComponent.showErrorWithLogTranslation("page.errorMessage.ria_errormessage_repeattransfer_general");
    }
    this.loadingProvider.hide();
  }
}



// WEBPACK FOOTER //
// ./src/components/activity-item/activity-item.ts